export const alert = {
  title: "Important",
  greeting: "Bonjour",
  user_default: "Utilisateur",
  feature_title: "Complétez vos infos bancaires",
  feature_description: "Pour créer dans",
  feature_1: "Devis professionnels",
  feature_2: "Factures détaillées",
  feature_3: "Avoirs et notes de crédit",
  requirements_title: "📋 Informations requises :",
  req_bank_name: "Nom de la banque",
  req_iban: "IBAN / Numéro de compte",
  req_bic: "Code BIC/SWIFT",
  req_address: "RIB",
  add_button: "Ajouter les infos bancaires",
  remind_later: "Me rappeler plus tard",
  footer: "⏱️ Prend moins de 2 minutes",
};
